import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SelectedAppointmentDetails, WorkOrderDetails } from 'projects/Administration/src/app/business-entities/auto-key-model';
import { SelectListItemViewModel } from 'projects/Administration/src/app/business-entities/select-list-item-view-model';
import { AutoKeyBusinessService } from 'projects/Administration/src/app/business-services/auto-key.service';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { PaymentType } from 'projects/Autofacets-Core/src/app/utils/enums';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-with-work-order',
  templateUrl: './with-work-order.component.html'
})
export class WithWorkOrderComponent implements OnInit {

  lockerId: string;
  closeResult: string;
  workOrderDetails: WorkOrderDetails[];
  dealerList: Array<SelectListItemViewModel>;
  selectedDealerId: string = '';
  dealerSelected: string = '';
  paginationSub: Subscription;
  isWeekViewOn: boolean = false;
  isTodayViewOn: boolean = true;
  appointmentdetails : SelectedAppointmentDetails
  @Input() currentDealerId: string = '';
  @Input() onlyAutoKey: boolean = true;
  @Output() selectedAppointmentDetails = new EventEmitter<any>();

  constructor(private service: AutoKeyBusinessService,
    public pService: CustomPaggerService) {
    this.pService.searchby = ['licensePlate', 'workorderNo'];
    this.pService.searchTerm = '';
  }

  ngOnInit(): void {
    this.dealerList = this.service.dealerList;
    this.getWorkOrderDeatils();
    let appointmentdetails = {
      appointmentId : ''
    }
    this.selectedAppointmentDetails.emit(appointmentdetails);
  }

  getWorkOrderDeatils() {
    let model = {
      DealerId: this.currentDealerId,
      Date: new Date(),
      OnlyAutoKey: this.onlyAutoKey,
      IsWeekData: this.isWeekViewOn
    }
    this.service.getWorkOrderDetails(model).then(
      res => {
        if (res.responseObject.length !== undefined) {
          this.pService.dataSource = res.responseObject;
          this.paginationSub = this.pService.dealers$.subscribe(result => {
            this.workOrderDetails = result;
            this.workOrderDetails.forEach(element => {             
              element.isShareboxPaymentMethod = false
              if(element.paymentType == PaymentType.B2C ){
                element.isShareboxPaymentMethod = true
              }
            })
          });
        }
        else {
          this.workOrderDetails = [];
        }
      }
    )
  }


  onClickChangeView(isWeek: boolean) {
    if (isWeek) {
      this.isWeekViewOn = true;
      this.isTodayViewOn = false;
      this.getWorkOrderDeatils();
    } else {
      this.isWeekViewOn = false;
      this.isTodayViewOn = true;
      this.getWorkOrderDeatils();
    }
  }

  refresh() {
    this.getWorkOrderDeatils();
  }

  findObject(object: any) {
    this.appointmentdetails = {
      appointmentId : object.appointmentId,
      isShareboxPaymentMethod: object.isShareboxPaymentMethod,
      finalInvoiceAmount: object.finalInvoiceAmount
    }
    this.selectedAppointmentDetails.emit(this.appointmentdetails);
  }
}
